import { useMe } from '../auth/useMe'

/**
 * Pill de disponibilidad del asesor, en la derecha del header.
 *
 * En pausa el asesor sale de la rotación round-robin y no recibe asignaciones
 * nuevas, pero CONSERVA las conversaciones que ya tiene: quitarle los casos
 * abiertos a quien se va a almorzar dejaría al cliente sin nadie a mitad de
 * conversación. El corte lo hace el backend en `_orden_rotacion`, no solo el
 * color del pill.
 */
export default function AvailabilityPill() {
  const { available, rotationPosition, rotationSize, error, setAvailable } = useMe()

  const ordinal =
    rotationPosition === 1 ? '1º'
    : rotationPosition === 2 ? '2º'
    : rotationPosition ? `${rotationPosition}º`
    : null

  return (
    <div className="flex items-center gap-3">
      <div className="text-right leading-tight">
        <p className="text-body font-bold text-ink">
          {available ? 'Recibiendo asignaciones' : 'En pausa'}
        </p>
        <p className="text-[11px] text-ink-muted">
          {error
            ? error
            : available && ordinal
              ? `Eres el ${ordinal} en la rotación${rotationSize ? ` de ${rotationSize}` : ''}`
              : available
                ? 'Sin posición asignada todavía'
                : 'No recibirás conversaciones nuevas'}
        </p>
      </div>

      <button
        onClick={() => void setAvailable(!available)}
        className={`flex items-center gap-2 rounded-chip border px-[13px] py-[7px] text-body font-bold transition-colors ${
          available
            ? 'border-brand-border bg-brand-light text-brand-hover'
            : 'border-warn-border bg-warn-light text-warn'
        }`}
        title={available
          ? 'Pausar: dejas de recibir conversaciones nuevas'
          : 'Reanudar: vuelves a la rotación'}
      >
        <span
          className={`h-2 w-2 rounded-full ${available ? 'bg-brand' : 'bg-warn'}`}
          aria-hidden
        />
        {available ? 'Disponible' : 'En pausa'}
      </button>
    </div>
  )
}
